// extracted by mini-css-extract-plugin
module.exports = {"brand":"_1waEx","filterBrandsWrapper":"G-zuJ","title":"_2qDbN"};